import { ErrorConnectingToProviderDescriptionText } from './removeAndAddFileProvider.locstring.json';
import { CouldNotConnectToAccountTitleText } from '../strings.locstring.json';
import loc, { format } from 'owa-localize';
import addFileProviderOrchestrator from './addFileProvider';
import removeFileProviderOrchestrator from './removeFileProvider';
import { removeAndAddFileProvider } from '../actions/publicActions';
import { FileProviderType } from '../utils/constants';
import getProviderBrandName from '../utils/getProviderBrandName';
import { confirm, DialogResponse } from 'owa-confirm-dialog';

import { orchestrator } from 'satcheljs';

orchestrator(removeAndAddFileProvider, actionMessage => {
    removeAndAddFileProviderOrchestrator(actionMessage.providerType);
});

export default async function removeAndAddFileProviderOrchestrator(providerType: FileProviderType) {
    const providerDisplayName = getProviderBrandName(providerType);

    try {
        await removeFileProviderOrchestrator(providerType);
        const response: DialogResponse = await askUserForAddingProvider(providerDisplayName);
        if (response === DialogResponse.ok) {
            await addFileProviderOrchestrator(providerType);
        }
    } catch (error) {
        /* Ignore the error */
    }
}

function askUserForAddingProvider(providerDisplayName: string): Promise<DialogResponse> {
    return confirm(
        loc(CouldNotConnectToAccountTitleText),
        format(loc(ErrorConnectingToProviderDescriptionText), providerDisplayName),
        false
    );
}
